import {
  useLocation,
  UNSAFE_NavigationContext as NavigationContext
} from "react-router-dom";
import { useContext, useEffect, useCallback } from "react";

const useBlockInCallNavigation = ({
  when,
  onBlocked,
  allowedPathPrefix,
  unloadMessage = ""
}) => {
  const { navigator } = useContext(NavigationContext);
  const location = useLocation();

  const blocker = useCallback(
    (tx) => {
      const nextPath = tx.location.pathname;
      const isAllowedPath =
        nextPath === allowedPathPrefix ||
        nextPath.startsWith(`${allowedPathPrefix}/`);
      if (isAllowedPath && nextPath !== location.pathname) {
        tx.retry();
        return;
      }
      if (!isAllowedPath) {
        onBlocked?.();
      }
    },
    [allowedPathPrefix, location.pathname, onBlocked]
  );

  useEffect(() => {
    if (!when) return undefined;
    const unblock = navigator.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        }
      };
      blocker(autoUnblockingTx);
    });
    return unblock;
  }, [blocker, navigator, when]);

  useEffect(() => {
    if (!when) return undefined;
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = unloadMessage;
      return unloadMessage;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [unloadMessage, when]);
};

export default useBlockInCallNavigation;
